import { useMemo } from "react";
import { useSelector } from "react-redux";
import { isConsentMandatory } from "../consent";
import {
  selectActiveLoyaltyProvider,
  selectBusinessData,
  selectCustomerLoyaltyInfo,
  selectLoyaltyProgramDetails,
} from "../selectors";

/**
 * Is loyalty enrolment consent in play for this merchant, provider and customer right now?
 *
 * The gate on every consent affordance. `useCustomerConsent` calls it for its own `isMandatory`;
 * this is the standalone form, for a surface that only needs the question answered (the cart
 * strip does) without owning the enrolment flow.
 */
export function useIsConsentMandatory(): boolean {
  const businessData = useSelector(selectBusinessData);
  const activeProvider = useSelector(selectActiveLoyaltyProvider);
  const programDetails = useSelector(selectLoyaltyProgramDetails);
  const customerLoyaltyInfo = useSelector(selectCustomerLoyaltyInfo);

  return useMemo(
    () =>
      isConsentMandatory({
        isMandatoryForBusiness: businessData?.isCustomerConsentMandatory,
        activeProvider,
        programDetails,
        customerLoyaltyInfo,
      }),
    [businessData?.isCustomerConsentMandatory, activeProvider, programDetails, customerLoyaltyInfo],
  );
}
